import { IPositionLevel } from "../interfaces/positionLevel";

const createNewPositionLevel = (): IPositionLevel => {
    return { id: "", name: "" }
}

export { createNewPositionLevel };
